(function() {
  function legacyCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    document.body.removeChild(textarea);
    return copied ? Promise.resolve() : Promise.reject();
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function() {
        return legacyCopy(text);
      });
    }

    return legacyCopy(text);
  }

  function resetCopyState(offer) {
    var button = offer.querySelector('[data-discount-copy]');
    if (!button) return;

    var label = button.querySelector('[data-discount-copy-label]');
    window.clearTimeout(button.discountCopyTimer);
    button.classList.remove('is-copied');
    if (label) label.textContent = button.getAttribute('data-copy-label');
  }

  function supportsVariant(offer, variantId) {
    var allowedIds = offer.getAttribute('data-allowed-variant-ids');
    if (!allowedIds) return true;
    if (!variantId) return false;

    return allowedIds.split(',').indexOf(String(variantId)) !== -1;
  }

  function updateOfferGroup(group, variantId) {
    var offers = Array.prototype.slice.call(group.querySelectorAll('[data-market-discount-offer]'));
    var selectedOffer = null;
    var selectedPriority = -Infinity;

    offers.forEach(function(offer) {
      if (!supportsVariant(offer, variantId)) return;

      var priority = parseInt(offer.getAttribute('data-offer-priority'), 10);
      if (isNaN(priority)) priority = 0;

      if (!selectedOffer || priority > selectedPriority) {
        selectedOffer = offer;
        selectedPriority = priority;
      }
    });

    offers.forEach(function(offer) {
      var shouldHide = offer !== selectedOffer;
      if (shouldHide && !offer.hidden) resetCopyState(offer);
      offer.hidden = shouldHide;
    });

    group.setAttribute('data-current-variant-id', variantId || '');
  }

  function updateAllOfferGroups(variantId) {
    document.querySelectorAll('[data-market-discount-offers]').forEach(function(group) {
      updateOfferGroup(group, variantId);
    });
  }

  document.querySelectorAll('[data-market-discount-offers]').forEach(function(group) {
    updateOfferGroup(group, group.getAttribute('data-current-variant-id'));
  });

  document.addEventListener('variant:change', function(event) {
    var variant = event.detail && event.detail.variant;
    updateAllOfferGroups(variant ? variant.id : null);
  });

  document.addEventListener('click', function(event) {
    if (!event.target.closest) return;
    var button = event.target.closest('[data-discount-copy]');
    if (!button) return;

    var code = button.getAttribute('data-discount-code');
    var label = button.querySelector('[data-discount-copy-label]');
    if (!code || !label) return;

    copyText(code).then(function() {
      window.clearTimeout(button.discountCopyTimer);
      label.textContent = button.getAttribute('data-copied-label');
      button.classList.add('is-copied');

      button.discountCopyTimer = window.setTimeout(function() {
        label.textContent = button.getAttribute('data-copy-label');
        button.classList.remove('is-copied');
      }, 2000);
    });
  });
})();
